import { render, staticRenderFns } from "./Postgraft.vue?vue&type=template&id=1b09e09a&"
import script from "./Postgraft.vue?vue&type=script&lang=js&"
export * from "./Postgraft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports